// region Custom Parsley Validators
window.Parsley
	.addValidator('filemaxmegabytes', {
		requirementType: 'string',
		validateString: function (value, requirement, parsleyInstance) {

			if (!('FormData' in window)) {
				return true;
			}

			var file = parsleyInstance.$element[0].files;
			var maxBytes = requirement * 1048576;

			if (file.length == 0) {
				return true;
			}

			return file.length === 1 && file[0].size <= maxBytes;

		},
		messages: {
			en: 'File is too big'
		}
	})
	.addValidator('filemimetypes', {
		requirementType: 'string',
		validateString: function (value, requirement, parsleyInstance) {

			if (!('FormData' in window)) {
				return true;
			}

			var file = parsleyInstance.$element[0].files;

			if (file.length === 0) {
				return true;
			}

			var allowedMimeTypes = requirement.replace(/\s/g, '').split(',');
			return allowedMimeTypes.indexOf(file[0].type) !== -1;

		},
		messages: {
			en: 'This is not a proper image file.'
		}
	});

jQuery.extend(jQuery.expr[':'], {
	invalid: function (elem, index, match) {
		return elem.validity !== undefined && elem.validity.valid === false;
	}
});
// endregion

// region Form Field State Classes
// Handles input states as class names on the parent to assist with styling when needed
const formFieldSelector = '.form-field input, .form-field textarea, .form-field select';
const prefilledTypes = ['date', 'month', 'number']; // These always have text in the text box, so the label should always be in the active state
$(formFieldSelector).each(function () {
	$(this).closest('.form-field').toggleClass('not-empty', $(this).val() !== '');

	if ($(this).attr('required') && $(this).attr('required') !== '') {
		$(this).closest('.form-field').addClass('field-required');
		$(this).closest('.form-group').addClass('group-has-required');
	}

	if (!!prefilledTypes.find(e => e === this.type)) {
		$(this).closest('.form-field').addClass('prefilled');
	}
});

$(document).on('focus', formFieldSelector, function () {
	$(this).closest('.form-field').addClass('focused');
});

$(document).on('blur', formFieldSelector, function () {
	$(this).closest('.form-field').removeClass('focused');
});

$(document).on('keydown keyup change load input', formFieldSelector, function () {
	$(this).closest('.form-field').toggleClass('not-empty', $(this).val() !== '');
});

$('#SelectedReasons').on('change', function () {
	//$('.form-field-event-date').toggle($(this).val() === 'private');
	//$('.form-field-attendees').toggle($(this).val() === 'private');

	
	//if ($(this).val() === 'private') {
	//	$('#formtitle').html('GROUP EVENT INQUIRY');
	//	$('#divaddress').hide();
	//	$('#divcity').hide();
	//	$('#divstate').hide();
	//	$('#divzipcode').hide();
	//	$('#divDuration').show();
	//	$('#divfromsource').show();
	//	$("#select-EventLeadSource").attr('required', true);
	//	$("#input-attendes").attr('required', true);
	//	$("#input-Edate").attr('required', true);
	//	$("#select-Etime").attr('required', true);
	//	$("#input-Eduration").attr('required', true);
	//}
	//else {
	//	$('#divfromsource').hide();
	//	$('#formtitle').html('GROUP EVENT INQUIRY');
	//	$('#divaddress').show();
	//	$('#divcity').show();
	//	$('#divstate').show();
	//	$('#divzipcode').show();	
	//	$('#divDuration').hide();
	//	$("#select-EventLeadSource").attr('required', false);
	//	$("#input-attendes").attr('required', false);
	//	$("#input-Edate").attr('required', false);
	//	$("#select-Etime").attr('required', false);
	//	$("#input-Eduration").attr('required', false);
 //   }
	
	
    if (window.location.search.indexOf('drinkonus') > -1) {
        window.GTM_contactFormReason = 'drinks';
    } else {
        window.GTM_contactFormReason = $(this).val();
    }
});

$(function () {
	var hash = window.location.hash.substr(1);
	$('#SelectedReasons').find('[value="' + hash + '"]').attr('selected', 'selected');
    $('#SelectedReasons').trigger('change');
    if (window.location.search.indexOf('drinkonus') > -1) {
        window.GTM_contactFormReason = 'drinks';
    }
});

// endregion

// region SpyTender Popup
function createSpytenderPopup({ successAction, content }) {

	const template = `
					<div class="popup">
						<div class="popup-container">
							<div class="popup-head">
								<a href="#" class="button button-1 popup-close">&times</a>
							</div>
							<div class="popup-body show-frame">
								<iframe width="1080" height="900" src="about:blank" class="popup-frame"></iframe>
								<textarea class="popup-code">${content}</textarea>
							</div>
							<div class="popup-tools"></div>
						</div>
					</div>
					`;

	const $popup = $(template);
	const $body = $popup.find('.popup-body');
	const $tools = $popup.find('.popup-tools');

	const $codeButton = $('<a href="#" class="button button-1">Toggle Code View</a>');

	$codeButton.on('click', function (e) {
		e.preventDefault();
		$body.toggleClass('show-frame show-code');
	});

	$tools.append($codeButton);

	if ('execCommand' in document) {
		const $copyButton = $('<a href="#" class="button button-1">Copy Invite</a>');

		$copyButton.on('click', function (e) {
			e.preventDefault();
			try {

				if ($body.hasClass('show-frame')) {
					const doc = $body.find('.popup-frame')[0].contentDocument;

					console.log(doc);

					$body.find('.popup-frame')[0].contentWindow.focus();
					doc.designMode = 'on';
					doc.execCommand('selectAll', false, null);
					doc.execCommand('copy', false, null);
					doc.designMode = 'off';
				} else {
					var copyText = $body.find('.popup-code')[0];

					/* Select the text field */
					copyText.select();

					/* Copy the text inside the text field */
					document.execCommand('copy');
				}
			} catch (e) {
				alert('An error occurred while trying to copy your invite. Please try again later. Alternatively, you can also right-click on the template, Select All, and manually copy the content.');
			}
		});

		$tools.append($copyButton);
	}

	$('body').append($popup);

	$popup.on('click', e => {
		if (!$(e.target).closest('.popup-container').length || $(e.target).closest('.popup-close').length) {
			e.preventDefault();
			$popup.remove();
		}
	});

	$(document).on('keydown', function closePopup(e) {
		if (e.key === 'Escape') {
			e.preventDefault();
			$popup.remove();
			$(document).off('click', closePopup);
		}
	});

	const frameDoc = $body.find('iframe')[0].contentWindow.document;

	frameDoc.open();
	frameDoc.write(content);
	frameDoc.close();
}

// endregion


$('.form-ajax').on('submit', function (e) {
	e.preventDefault();

	const $form = $(this);
	const $wrap = $form.parent('.form-wrapper');
	const $message = $wrap.find('.form-success');
	const $btn = $form.find('.button--formsubmit');

	const action = $form.attr('action');
	const data = new FormData($form[0]);

	let parsleyInstance = $form.parsley();

	parsleyInstance.on('field:error', (fieldInstance) => {
		console.log(fieldInstance.validationResult);
		if (!$(fieldInstance.$element).is(':visible')) {
			fieldInstance.validationResult = true;
		}
    });

    $('.g-recaptcha').removeClass('recaptcha-border');
    $form.find('.recaptcha-error').find('.recaptcha-error-message').remove();
    $form.find('.form-errors').hide();

	if (parsleyInstance.isValid()) {
		if ($('#SelectedReasons').find(":selected").val() === "Select") {
			var response = [];
			response.item = 'SelectedReasons';
			response.message = 'Please select a Event Type';

			var FieldInstance = $('[name=' + response.item + ']').parsley(),
				errorName = response.item + '-custom';
			/**
			 * You'll probably need to remove the error first, so the error
			 * doesn't show multiple times
			 */
			window.ParsleyUI.removeError(FieldInstance, errorName);

			// now display the error
			window.ParsleyUI.addError(FieldInstance, errorName, response.message);

			return;
		}
		


		$btn.prop('disabled', true);
		//Begin ajax method
		$.ajax({
			url: action,
			method: 'POST',
			data: data,
			processData: false,
			contentType: false,
			encType: 'multipart/form-data',
            success: function (response) {
                console.log(response); //remove after testing
				const { successAction, StackTraceString } = response;
				if (StackTraceString) console.log(StackTraceString);

				if (successAction === 'Message') {
					if (ga) {
						ga('send', 'event', 'contact', 'click', window.GTM_contactFormReason);
					}

					$form[0].reset();
					$form.hide('slow');
					$message.show('slow');
					$message.focus();
				}

				if (successAction === 'Popup') {
					createSpytenderPopup(response);
				}

			}, error: function (err) {
                const errors = JSON.parse(err.responseText);

                if (errors.general && errors.general.length) {
                    if (!$form.find('.form-errors').length) {
                        const $newErrors = $('<div class="form-errors" />');
                        $newErrors.append('<p class="form-errors-label">Sorry, the following error(s) have occurred:</p>');
                        $newErrors.append('<ul class="form-errors-list" />');
                        $form.prepend($newErrors);
                    }

                    const $errors = $form.find('.form-errors');

                    $errors.show();

                    const $errorsList = $errors.find('.form-errors-list');

                    $errorsList.find('.form-errors-message').remove();

                    errors.general.forEach(message => {
                        const $message = $(`<li class="form-errors-message">${message}</li>`);
                        $errorsList.append($message);
                    });

                    $('html, body').animate({
                        scrollTop: $form.offset().top
                    });
                }

                if (errors.captcha && errors.captcha.length) {
                    $('.g-recaptcha').addClass('recaptcha-border');

                    if (!$('.recaptcha-error').length) {
                        $('.g-recaptcha').after('<div class="recaptcha-error" />');
                    }

                    const $recaptchaError = $('.recaptcha-error');

                    $recaptchaError.find('.recaptcha-error-message').remove();

                    errors.captcha.forEach(message => {
                        const $message = $(`<p class="recaptcha-error-message">${message}</p>`);
                        $recaptchaError.append($message);
                    });
                }
			},
			complete: function () {
				$btn.prop('disabled', false);
				if (grecaptcha) grecaptcha.reset();
			}
		});
	}
});